
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"shp0",attrs:{"d":"M50 104.1h-7.3c-3.7 0-6.7 3-6.7 6.7v21c0 3.7 3 6.7 6.7 6.7H50c3.7 0 6.7-3 6.7-6.7v-21c0-3.7-3-6.7-6.7-6.7zM50 25.4h-7.3c-3.7 0-6.7 3-6.7 6.7v21c0 3.7 3 6.7 6.7 6.7H50c3.7 0 6.7-3 6.7-6.7v-21c0-3.7-3-6.7-6.7-6.7zM121.3 25.4H114c-3.7 0-6.7 3-6.7 6.7v21c0 3.7 3 6.7 6.7 6.7h7.3c3.7 0 6.7-3 6.7-6.7v-21c0-3.7-3-6.7-6.7-6.7zM121.3 104.1H114c-3.7 0-6.7 3-6.7 6.7v21c0 3.7 3 6.7 6.7 6.7h7.3c3.7 0 6.7-3 6.7-6.7v-21c0-3.7-3-6.7-6.7-6.7zM82 32.7c-4.8 0-8.8 3.3-9.7 7.7 0 .2-.2.4-.5.4H60.7c-.3 0-.5.2-.5.5v2.5c0 .3.2.5.5.5h11.1c.2 0 .4.2.5.4.8 3.7 3.7 6.7 7.5 7.6.2.1.4.3.4.5v10.6c0 .2-.1.4-.3.5-2.3.8-3.9 3-3.9 5.7v24.9c0 2.5 1.6 4.9 3.9 5.7.2.1.3.3.3.5v10.5c0 .2-.2.4-.4.5-3.7.8-6.7 3.7-7.5 7.6 0 .2-.3.4-.5.4H60.7c-.3 0-.5.2-.5.5v2.5c0 .3.2.5.5.5h11.1c.2 0 .4.2.5.4 1 4.4 5 7.7 9.6 7.7 4.8 0 8.8-3.3 9.7-7.7 0-.2.2-.4.5-.4h11.1c.3 0 .5-.2.5-.5v-2.5c0-.3-.2-.5-.5-.5H92.1c-.2 0-.4-.2-.5-.4-.8-3.7-3.7-6.8-7.5-7.6-.2-.1-.4-.3-.4-.5v-10.5c0-.2.1-.4.3-.5 2.3-.8 3.9-3 3.9-5.7V69.6c0-2.5-1.6-4.9-3.9-5.7-.2-.1-.3-.3-.3-.5V52.9c0-.2.2-.4.4-.5 3.7-.8 6.7-3.7 7.5-7.6 0-.2.3-.4.5-.4h11.1c.3 0 .5-.2.5-.5v-2.5c0-.3-.2-.5-.5-.5H92.1c-.2 0-.4-.2-.5-.4-.8-4.5-4.8-7.8-9.6-7.8z"}})])
          )
        }
      }
    